import { type Virtualizer } from "@tanstack/react-virtual";
import { createStore } from "@xstate/store";

export const virtualizerStore = createStore({
  context: {
    virtualizer: null as Virtualizer<HTMLDivElement, Element> | null,
  },
  on: {
    registerVirtualizer: (
      context,
      { virtualizer }: { virtualizer: Virtualizer<HTMLDivElement, Element> }
    ) => ({
      ...context,
      virtualizer,
    }),
  },
});
